// Content SEO field map per entity type (mirrors backend seo_content.FIELD_MAP).
// Keys are generic and stable → future content types need no schema change.
export const FIELD_MAP = {
  product: [
    { key: "main", label: "Product Description" },
    { key: "info", label: "Product Information" },
    { key: "safety", label: "Safety Information", safety: true },
    { key: "additional", label: "Additional Information" },
  ],
  category: [
    { key: "intro", label: "Category Introduction" },
    { key: "main", label: "Buying Guide" },
    { key: "additional", label: "Additional Information" },
  ],
  brand: [
    { key: "intro", label: "About the Brand" },
    { key: "main", label: "Why Choose This Brand" },
    { key: "additional", label: "Additional Information" },
  ],
  page: [
    { key: "intro", label: "SEO Introduction" },
    { key: "main", label: "Main Content" },
    { key: "additional", label: "Additional Information" },
  ],
  bundle: [
    { key: "main", label: "Bundle Description" },
    { key: "additional", label: "Additional Information" },
  ],
};

export function fieldsFor(type) {
  return FIELD_MAP[type] || FIELD_MAP.page;
}
